module.exports = __webpack_public_path__ + "static/media/bannerLogo.55fe1b19.png";